import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../../../store';
import { closeFeedbackPopup } from '../../../actions/feedback';
import { FeedbackPopup } from './FeedbackPopup';

export const mapStateToProps = (state: IState) => ({
  isOpen: state.feedback.isPopupOpened,
});

export const mapDispatchToProps = (dispatch: Dispatch<{}>) => ({
  onClose() {
    dispatch(closeFeedbackPopup());
  },
});

export const FeedbackPopupContainer = connect(mapStateToProps, mapDispatchToProps)(FeedbackPopup);
